<template>
  <ContentWrapperControl>
    <div class="mt-4">
      <!-- <span class="font-bold text-primary">{{ this.election.title }}</span> -->
      <div
        class="bg-white rounded-xl shadow-md mt-4 p-5 flex flex-col items-start text-gray-800 leading-normal"
      >
        <ElectionPolicyControl />
          <ButtonControl
            class="w-full"
          >
            {{ this.lang("lbl_0000015") }}
          </ButtonControl>
      </div>
    </div>
  </ContentWrapperControl>
</template>

<script>
import ContentWrapperControl from "@/components/controls/ContentWrapperControl.vue";
import ElectionPolicyControl from "@/components/controls/ElectionPolicyControl.vue";
import ButtonControl from "@/components/controls/ButtonControl.vue";
import GA from "@/services/GA";
import mixin from "@/mixin.js";

export default {
  mixins: [mixin],
  components: {
    ContentWrapperControl,
    ElectionPolicyControl,
    ButtonControl,
  },
  data() {
    return {
      username: "",
      password: "",
      mobile: "",
      email: "",
      election: {
        code: null,
        title: null,
        date: null,
      },
    };
  },
  mounted() {
    this.$emit("checkauth");
    this.$emit("nofooter", false);
    this.$emit("shownavbar", {
      title: this.lang("lbl_0000351"),
      show: true,
      back: true,
    });

    let state = this.$store.state;
    this.username = state.info.username;
    this.password = state.password;
    this.email = state.info.email;

    if(!state.ga.code){
      this.election.code = state.ga.code;
      this.election.title = state.ga.title;
      this.election.date = state.ga.date;
      this.loadElection();
      return;
    }
  },
  methods: {
    loadElection() {
      this.$emit("showloader");
      GA.getCurrentElection()
        .then((response) => {
          if (response.status === 200) {
            const { code, title, date } = response.data.data;

            this.$store.state.ga.code = code;
            this.election.code = code;
            this.$store.state.ga.title = title;
            this.election.title = title;
            this.$store.state.ga.date = date;
            this.election.date = date;

            console.log(this.$store.state.ga);
            this.loadCandidates();
          }
        })
        .catch((error) => {
          this.$emit("error", error);
        })
        .finally(() => this.$emit("hideloader"));
    },
    loadCandidates() {
      this.$emit("showloader");
      GA.getAllCandidates(this.election.code, this.$store.state.info.hash)
        .then((response) => {
          if (response.status === 200) {
            const { candidates } = response.data.data;
            this.$store.state.ga.candidates = candidates;
            console.log(candidates);
          }
        })
        .catch((error) => {
          this.$emit("error", error);
        })
        .finally(() => this.$emit("hideloader"));
    },
  },
};
</script>
